import { API } from 'aws-amplify';

export const deleteSchool = async (categoryId: string) => {
  const data = await API.post('AiFormRequest', '/save?key=delete', {
    body: {
      categoryId,
    },
  });
  return data;
};
